export const dateTimeFormatter = (datetime) => {
  const [date, time] = datetime.split(" ");
  const dateFormatted = `${date.split("-")[2]}/${date.split("-")[1]}/${
    date.split("-")[0]
  }`;
  return `${dateFormatted} - ${time}`;
};

export const cpfFormatter = (cpf) => {
  if (cpfValidator(cpf)) {
    return `${cpf.substring(0, 3)}.${cpf.substring(3, 6)}.${cpf.substring(
      6,
      9
    )}-${cpf.substring(9)}`;
  }
  return cpf;
};

export const cpfValidator = (cpf) => {
  if (!cpf) return "";
  if (cpf.length === 11) return true;
  return false;
};

export const cpfSpecialCharactersRemover = (cpf) => {
  const onlyIntegerRegex = "^[0-9]*$";

  const cpfArray = cpf.split("");

  const cpfOnlyNumbersArray = cpfArray.filter((character) =>
    character.match(onlyIntegerRegex)
  );

  return cpfOnlyNumbersArray.join("");
};

export const cnpjFormatter = (cnpj) => {
  const cnpjFormated = cnpj.replace(
    /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
    "$1.$2.$3/$4-$5"
  );
  return cnpjFormated;
};
